import { render, staticRenderFns } from "./MailingContent.vue?vue&type=template&id=5fc2e67c"
import script from "./MailingContent.vue?vue&type=script&lang=js"
export * from "./MailingContent.vue?vue&type=script&lang=js"
import style0 from "./MailingContent.vue?vue&type=style&index=0&id=5fc2e67c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports